import { motion } from "framer-motion";
import { SparklesIcon } from "lucide-react";
import { TFunction } from "i18next";
import { FC } from "react";

interface Props {
  t: TFunction;
}

/**
 * Welcome header shown when a thread has no messages yet.
 * Displays a friendly title/subtitle with subtle entrance animations.
 */
const ThreadWelcome: FC<Props> = ({ t }) => {
  return (
    <div className="mx-auto flex w-full max-w-[--thread-max-width] grow flex-col px-[--thread-padding-x]">
      <div className="flex w-full grow flex-col items-center justify-center">
        <div className="flex items-center justify-end gap-2">
          {/* Animated assistant glyph for a bit of delight */}
          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }} transition={{ delay: 0.5 }}>
            <SparklesIcon className="size-10 text-blue-500"  />
          </motion.div>
          <div className="flex size-full flex-col px-auto md:mt-20">
            {/* Title and subtitle fade/slide in sequentially */}
            <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }} transition={{ delay: 0.5 }} className="text-2xl font-semibold">
              {t("documentchat.empty.title")}
            </motion.div>
            <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }} transition={{ delay: 0.6 }} className="text-muted-foreground/65 text-xl">
              {t("documentchat.empty.subtitle")}
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThreadWelcome;
